<template>
  <div v-if="show">
    <div class="backdrop-content">{{ $t('upload') }}</div>
    <div class="backdrop"></div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      events: ['dragenter', 'dragover', 'dragleave', 'drop'],
      show: false,
      enterTarget: null,
    }
  },
  created() {
    window.addEventListener('dragenter', this.setActive)
    window.addEventListener('dragover', this.setActive)
    window.addEventListener('dragleave', this.setInactive)
    window.addEventListener('drop', this.onDropEventHandler)
    window.addEventListener('paste', this.onPasteEventHandler)
  },
  beforeDestroy() {
    window.removeEventListener('dragenter', this.setInactive)
    window.removeEventListener('dragover', this.setInactive)
    window.removeEventListener('dragleave', this.setInactive)
    window.removeEventListener('drop', this.onDropEventHandler)
    window.removeEventListener('paste', this.onPasteEventHandler)
  },
  methods: {
    setActive(e) {
      e.preventDefault()
      e.stopPropagation()
      if (e.dataTransfer.types.indexOf('Files') != -1) {
        this.show = true
        this.enterTarget = e.target;
      }
    },
    setInactive(e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.enterTarget == e.target) {
        this.show = false
      }
    },
    onDropEventHandler(event) {
      this.setInactive(event)
      this.$emit('drop', event)
    },
    onPasteEventHandler(event) {
      this.$emit('paste', event)
    },
  }
}
</script>

<style>
.backdrop-content {
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 120000;
  box-shadow: none;
  border: 5px dashed #fff;
  margin: 50px;
  text-align: center;
  font-size: 60px;
  padding-top: 30px;
}
.backdrop {
  z-index: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  text-align: center;
  white-space: nowrap;
  background: rgba(0,0,0,.3);
}
</style>